module.exports = __webpack_public_path__ + "static/assets/8bdc7c45afd569f10ea08b2d39c09a03.png";